import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { residences } from "../services/soar";
import ApartmentModal from "./ApartmentModal";
import LeaseHistory from "./LeaseHistory";
import Utilities from "./Utilities";
import PropertyContacts from "./PropertyContacts";
import ClientHistory from "./ClientHistory";
import ApartmentNotes from "./ApartmentNotes";
import ApartmentRelated from "./ApartmentRelated";

function Apartment(props) {
  const params = useParams();
  const [residenceData, setResidenceData] = useState({});
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    getResidenceData();
  }, []);

  const getResidenceData = async () => {
    const body = {
      command: "query",
      application:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
          : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
      keyword: "byid",
      ids: [params.id],
    };
    const data = await residences(body);
    setResidenceData(data.data[0]);
  };

  const handleActivateDeactivate = async () => {
    const body = {
      command: residenceData.active ? "deactivate" : "reactivate",
      application:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "5dae139e-d052-4bd8-499a31ac3c15"
          : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
      id: residenceData.id,
      modifiedBy: JSON.parse(localStorage.getItem("safyInfo")).user.azureId,
    };
    const response = await residences(body);
    if (response.code === "success") {
      setResidenceData({ ...residenceData, active: !residenceData.active });
      toast.success(
        `Apartment ${residenceData.active ? "deactivated" : "activated"}`
      );
    } else {
      toast.error("Error updating apartment status");
    }
  };

  const handleSave = async () => {
    let body = {
      command: residenceData.id ? "update" : "create",
      application:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
          : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
      name:
        residenceData.name !== "" ? residenceData.name : residenceData.address,
      type: "Independent",
      address: residenceData.address,
      city: residenceData.city,
      state: residenceData.state,
      zip: residenceData.zip,
      unit: residenceData.unit,
      doorCode: residenceData.doorCode,
      leaseStatus: residenceData.leaseStatus,
      placementStatus: residenceData.placementStatus,
      programUnit: residenceData.programUnit,
      programUnitName: residenceData.programUnitName,
    };

    if (residenceData.id) {
      body.id = residenceData.id;
    }

    return await residences(body);
  };

  return (
    <>
      <ApartmentModal
        data={residenceData}
        setData={setResidenceData}
        show={showModal}
        handleSave={handleSave}
        onHide={() => setShowModal(false)}
      />
      <div
        className={residenceData.active === false ? "bg-warning p-2" : "p-2"}
      >
        <div>
          <div className="row">
            <div className="col-6">
              <div className="mb-4">
                <div className="h5">{residenceData.unit}</div>
                {residenceData.name !== residenceData.address && (
                  <div className="h5">{residenceData.name}</div>
                )}
                <div>
                  <i
                    className="fas fa-map-pin text-danger me-2"
                    onClick={() =>
                      window.open(
                        `https://maps.google.com/?q=${residenceData.address} ${residenceData.city} ${residenceData.state}`
                      )
                    }
                  />{" "}
                  {`${residenceData.address}, ${residenceData.city}, ${residenceData.state} ${residenceData.zip}`}
                </div>
                {residenceData.doorCode && (
                  <div
                    className="btn btn-sm btn-danger mt-2 fw-bold"
                    onClick={() => {
                      toast.info(`Door Code: ${residenceData.doorCode}`);
                    }}
                  >
                    Show Door Code
                  </div>
                )}
                <div className="m-4">
                  {`Program Unit: ${residenceData.programUnitName}`}
                </div>
                {residenceData.active === false && (
                  <div className="text-danger fw-bold m-4 h5">Inactive</div>
                )}
              </div>
            </div>
            <div className="col-4"></div>
            <div className="col-2 d-block">
              <div
                className="btn btn-sm btn-primary border-dark my-4 w-100"
                onClick={() => setShowModal(!showModal)}
              >
                Edit Apartment
              </div>
              <div className="mt-4">
                {residenceData.active ? (
                  <div
                    className="btn btn-sm btn-danger border-dark w-100"
                    onClick={handleActivateDeactivate}
                  >
                    Deactivate
                  </div>
                ) : (
                  <div
                    className="btn btn-sm btn-success w-100"
                    onClick={handleActivateDeactivate}
                  >
                    Activate
                  </div>
                )}
              </div>
            </div>
          </div>
          <PropertyContacts
            data={residenceData}
            refreshData={() => getResidenceData()}
          />
          <LeaseHistory
            data={residenceData}
            refreshData={() => getResidenceData()}
          />
          <ClientHistory
            data={residenceData}
            refreshData={() => getResidenceData()}
          />
          <Utilities
            data={residenceData}
            refreshData={() => getResidenceData()}
          />
          {/* <ExpandDiv title="Documents" className={`border p-2 mb-2 card-safy`}>
            <div className="row">
              <div className="col-11"></div>
              <div className="col-1">
                <i
                  className="fas fa-plus-circle fa-xl text-primary float-end me-2 mb-2"
                  role="button"
                ></i>
              </div>
            </div>
          </ExpandDiv> */}
          <ApartmentRelated
            data={residenceData}
            refreshData={() => getResidenceData()}
          />
          <ApartmentNotes
            data={residenceData}
            refreshData={() => getResidenceData()}
          />
        </div>
      </div>
    </>
  );
}

export default Apartment;
